module.exports = __webpack_public_path__ + "static/digipadala-agent-knb-8adfb9539bc2b96eee1d8dec1a9f7c71.png";